import getConfig from "~/config";
import {
    getAllResultParams
} from "~/stateGetter";
import {
    getResultQueryParams,
} from "~/statePresenter";
import modelApi from "~/backend/modelApi";
import {mockupCancel} from "~/data/cancelToken";
import authenticatedRequest from "~/backend/authenticatedRequest";
import identify from "~/identify";
import { defaultTableResults } from '~/config';

export default async function fetchModelTableResults({getState, modelId, dispatch, cancelToken = mockupCancel}) {
    let state = getState(),
        rawResultParams = getAllResultParams(state, modelId),
        baseUrl = getConfig().baseUrl;

    let queryParams = getResultQueryParams(state, modelId);

    if(rawResultParams.itemId === identify.NEW_ITEM) {
        return defaultTableResults;
    }

    let tableResults = await modelApi(
        baseUrl,
        queryParams.modelName,
        (foo) => authenticatedRequest(foo, dispatch)
    ).fetchResults({...queryParams, itemId: rawResultParams.itemId}, cancelToken);

    return tableResults;
}